import { render, staticRenderFns } from "./bottomView.vue?vue&type=template&id=a3b6dd96&scoped=true"
import script from "./bottomView.vue?vue&type=script&lang=js"
export * from "./bottomView.vue?vue&type=script&lang=js"
import style0 from "./bottomView.vue?vue&type=style&index=0&id=a3b6dd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b6dd96",
  null
  
)

export default component.exports